export default {
  // Header
  'header.fontSize': 'Font Size',
  'header.theme': 'Theme',
  'header.language': 'Language',
  'header.english': 'English',
  'header.telugu': 'Telugu',
  'header.home': 'Home',
  'header.about': 'About Us',
  'header.aboutFunctions': 'Functions',
  'header.aboutCitizenCharter': 'Citizen Charter',
  'header.aboutTeam': 'Team',
  'header.services': 'Services',
  'header.resources': 'Resources',
  'header.resourcesActsByLaws': 'Acts & By Laws',
  'header.resourcesGosCirculars': "GO's & Circulars",
  'header.resourcesFaqs': 'FAQs',
  'header.resourcesTraining': 'Training Materials',
  'header.gisMap': 'GIS Map',
  'header.rti': 'RTI',
  'header.contact': 'Contact Us',
  'header.helpDesk': 'Help Desk',
  'header.login': 'Login',
  'header.logout': 'Logout',
  'header.gotoERP': 'Go to ERP',
  'header.govtOfAP': 'GOVERNMENT OF ANDHRA PRADESH',
  'header.dtcp': 'Directorate of Town and Country Planning',
  'header.department': 'MA & UD Department, Government of Andhra Pradesh',
  'header.dtcpShort': 'DTCP',
  'header.cmName': 'Sri Nara Chandrababu Naidu',
  'header.cmTitle': "Hon'ble Chief Minister of AP",
  'header.ministerName': 'Sri Ponguru Narayana',
  'header.ministerTitle': "Hon'ble Minister for MA&UD",
  'header.directorName': 'Director of Town & Country Planning',
  'header.directorTitle': 'Head of Department, DTCP Andhra Pradesh',

  // Hero Carousel
  'hero.slide1.badge': 'Building Permissions',
  'hero.slide1.title': 'Streamlining Urban Development Approvals',
  'hero.slide1.subtitle': 'DTCP Andhra Pradesh processes building permissions, layout approvals, and regularization requests for 110+ Urban Local Bodies — fast, transparent, and fully online.',
  'hero.slide1.cta': 'Apply for Layout Approval',
  'hero.slide2.badge': 'Master Plans',
  'hero.slide2.title': 'Transparent Planning & Layout Systems',
  'hero.slide2.subtitle': 'Access geo-referenced Master Plans for all districts, land-use zoning maps, and development regulations — publicly available and downloadable for every citizen.',
  'hero.slide2.cta': 'View Master Plans',
  'hero.slide3.badge': 'Land Use Regulation',
  'hero.slide3.title': 'Regulated Growth for Every District',
  'hero.slide3.subtitle': 'DTCP enforces Development Control Regulations, issues Land Use Certificates, and coordinates with CRDA, GHMC, and all municipal planning authorities across AP.',
  'hero.slide3.cta': 'Land Use Certificate',
  'hero.slide4.badge': 'Online Services',
  'hero.slide4.title': 'Citizen-First Digital Planning Services',
  'hero.slide4.subtitle': 'Apply, track, download, and verify — all your planning permissions and certificates available 24×7 on the DPMS portal. Government services made accessible to every citizen.',
  'hero.slide4.cta': 'Open DPMS Portal',
  'hero.slide5.badge': 'Display Devices — GO Ms.No.253',
  'hero.slide5.title': 'Regulated Outdoor Advertising',
  'hero.slide5.subtitle': 'All outdoor advertisements — hoardings, unipoles, digital screens, banners — now require a License and Permission from your ULB. Apply online, track approvals, and stay compliant.',
  'hero.slide5.cta': 'Apply for License',
  // Hero / About stat strip
  'hero.udas': 'Urban Development Authorities',
  'hero.regionalOffices': 'Regional Offices',
  'hero.districts': 'Districts Covered',
  'hero.onlineServices': 'Online Services',

  // Flash News
  'flash.label': 'Flash News',

  // About Section
  'about.label': 'Who We Are',
  'about.title': 'About DTCP Andhra Pradesh',
  'about.description1': 'The Directorate of Town and Country Planning (DTCP), Andhra Pradesh is the apex statutory authority responsible for systematic and planned urban and rural development across the state. Established under the Andhra Pradesh Town Planning Act, DTCP has been guiding the growth of urban settlements for over a century.',
  'about.description2': 'DTCP formulates Master Plans for all Urban Local Bodies, issues Building Permissions and Layout Approvals, regulates land use under Development Control Regulations, and provides technical guidance to local governments in coordination with CRDA, GHMC, municipal corporations, and other planning authorities.',
  'about.mission': 'Our Mission',
  'about.missionText': 'Promote planned, inclusive, and sustainable development of urban and rural areas of AP',
  'about.vision': 'Our Vision',
  'about.visionText': 'Resilient, livable, and future-ready towns and cities across Andhra Pradesh by 2041',
  'about.cta': 'Learn More About DTCP',
  'about.yearsOfPlanning': 'Years of Planning',
  'about.stat.ulb': 'Urban Local Bodies',
  'about.stat.permissions': 'Permissions Issued',
  'about.stat.masterPlans': 'Master Plans Prepared',
  'about.stat.citizens': 'Citizens Served',
  'about.description': 'The Directorate of Town & Country Planning (DTCP) is the apex body for urban planning and development regulation in Andhra Pradesh.',
  'about.subtitle': 'Planning for a Better Tomorrow',
  // About page — sidebar, key functions & leadership
  'about.govtOfAP': 'Government of Andhra Pradesh',
  'about.planningAuthority': 'Town & Country Planning Authority',
  'about.urbanPlanning': 'Urban Planning',
  'about.urbanPlanningDesc': 'Preparation of Master Plans, zoning regulations and land-use planning for all Urban Local Bodies across Andhra Pradesh.',
  'about.buildingRegulation': 'Building Regulation',
  'about.buildingRegulationDesc': 'Issuance of building permissions and enforcement of Development Control Regulations to ensure safe, planned construction.',
  'about.layoutApprovals': 'Layout Approvals',
  'about.layoutApprovalsDesc': 'Approval and regularisation of residential and commercial layouts in line with planning norms and development standards.',

  // Leadership
  'leadership.title': 'Our Leadership',

  // Key Services
  'keyServices.title': 'Key Services',
  'keyServices.viewAll': 'View All Services',
  'keyServices.buildingPermissions': 'Building Permissions',
  'keyServices.layoutApprovals': 'Layout Approvals',
  'keyServices.landUseCertificate': 'Land Use Certificate',
  'keyServices.masterPlanAccess': 'Master Plan Access',
  'keyServices.regularization': 'Regularization',
  'keyServices.ltp': 'Licensed Technical Personnel',
  'keyServices.municipalAssets': 'Municipal Assets',
  'keyServices.ucims': 'UCIMS',

  // Quick Access
  'quickAccess.title': 'Quick Access',
  'quickAccess.buildingPermission': 'Building Permission',
  'quickAccess.layoutApproval': 'Layout Approval',
  'quickAccess.masterPlans': 'Master Plans',
  'quickAccess.onlineApplications': 'Online Applications',
  'quickAccess.goOrders': 'GO & Orders',
  'quickAccess.citizenServices': 'Citizen Services',
  'quickAccess.regularization': 'Regularization',
  'quickAccess.landUseCertificate': 'Land Use Certificate',

  // UDA Map
  'uda.title': 'Urban Development Authorities',
  'uda.subtitle': 'Explore all {{count}} UDAs across Andhra Pradesh',
  'uda.badge': '{{count}} UDAs',
  'uda.listTitle': 'UDAs',
  'uda.search': 'Search UDA...',
  'uda.district': 'District',

  // Resources
  'resources.title': 'Resources',
  'resources.description': 'Acts, government orders, FAQs, and training materials related to town planning and urban development.',
  'resources.actsByLaws': 'Acts & By Laws',
  'resources.gosCirculars': "GO's & Circulars",
  'resources.faqs': 'FAQs',
  'resources.trainingMaterials': 'Training Materials',

  // Citizen Services
  'citizen.title': 'Citizen Services',
  'citizen.trackTitle': 'Track Your Application',
  'citizen.trackSubtitle': 'Enter your reference number to check the status',
  'citizen.trackPlaceholder': 'e.g. DTCP/BP/2026/04521',
  'citizen.checkStatus': 'Check Status',
  'citizen.found': 'Application Found',
  'citizen.notFound': 'Application Not Found',
  'citizen.notFoundMsg': 'Please verify your reference number and try again.',

  // Online Services
  'online.title': 'Online Portals & Services',
  'online.visitPortal': 'Visit Portal',
  'online.helpTitle': 'Need Help with Your Application?',
  'online.helpSubtitle': 'Our support team is available to assist you with any queries',
  'online.callNow': 'Call Now',
  'online.raiseGrievance': 'Raise Grievance',

  // Announcements
  'announcements.title': 'News & Announcements',
  'announcements.news': 'News & Updates',
  'announcements.notices': 'Important Notices',
  'announcements.viewAll': 'View all',
  'announcements.tabNews': 'News',
  'announcements.tabCirculars': 'Circulars',
  'announcements.tabTenders': 'Tenders',

  // Gallery
  'gallery.title': 'Gallery',
  'gallery.photo': 'Photo',
  'gallery.imagesAndVideos': 'Images & Videos',
  'gallery.images': 'Images',
  'gallery.videos': 'Videos',
  'gallery.noVideos': 'No videos published yet',
  'gallery.noImages': 'No images published yet',
  'gallery.prev': 'Previous',
  'gallery.next': 'Next',
  'location.title': 'Our Location',
  'location.fullScreen': 'Full screen',
  'location.exitFullScreen': 'Exit full screen',

  // Services Section (legacy)
  'services.title': 'DTCP Services',
  'services.description': 'Access a wide range of town planning services online.',
  'services.ctaTitle': 'Access DTCP Services Online',
  'services.ctaDescription': 'Log in to the DTCP portal to access the full range of planning services.',
  'services.ctaButton': 'Get Started',

  // Services Section — UI controls
  'services.searchPlaceholder': 'Search services...',
  'services.expandAll': 'Expand All',
  'services.collapseAll': 'Collapse All',
  'services.serviceSingular': 'service',
  'services.servicePlural': 'services',
  'services.noResults': 'No services found',
  'services.adjustSearch': 'Try adjusting your search term',
  'services.close': 'Close',
  'services.ddRulesPanelTitle': 'Display Devices — Rules, Fees & FAQ (GO Ms.No.253)',

  // Services Section — Category titles
  'services.cat.bp.title': 'Online Building Permissions (APDPMS)',
  'services.cat.la.title': 'Layout Approvals',
  'services.cat.lrs.title': 'Layout Regularization Scheme (LRS)',
  'services.cat.bps.title': 'Building Penalization Scheme (BPS)',
  'services.cat.clu.title': 'Change of Land Use / NALA',
  'services.cat.mp.title': 'Master Plans',
  'services.cat.tdr.title': 'Transferable Development Rights (TDR)',
  'services.cat.dd.title': 'Display Devices (GO Ms.No.253)',
  'services.cat.tt.title': 'Telecom Tower Permissions',
  'services.cat.st.title': 'Smart Townships',
  'services.cat.uda.title': 'UDA Services',

  // Services Section — Sub-service labels
  'services.item.bp-1': 'Apply for Building Permission',
  'services.item.bp-2': 'Track Application Status',
  'services.item.bp-3': 'Download Approved Plans',
  'services.item.bp-4': 'Occupancy Certificate',
  'services.item.bp-5': 'Completion Certificate',
  'services.item.la-1': 'Apply for Layout Permission',
  'services.item.la-2': 'Track Layout Application Status',
  'services.item.la-3': 'Download Layout Approvals',
  'services.item.lrs-1': 'Apply for LRS',
  'services.item.lrs-2': 'Track LRS Application Status',
  'services.item.lrs-3': 'LRS Fee Calculator',
  'services.item.lrs-4': 'Download LRS Certificate',
  'services.item.lrs-5': 'About LRS Scheme',
  'services.item.bps-1': 'Apply for BPS',
  'services.item.bps-2': 'Track BPS Application Status',
  'services.item.bps-3': 'BPS Penalty Calculator',
  'services.item.bps-4': 'Download BPS Certificate',
  'services.item.bps-5': 'About BPS Scheme',
  'services.item.clu-1': 'Apply for Change of Land Use',
  'services.item.clu-2': 'NALA Application',
  'services.item.clu-3': 'Track Application Status',
  'services.item.mp-1': 'View Master Plans',
  'services.item.mp-2': 'Zoning Information',
  'services.item.mp-3': 'Land Use Classification',
  'services.item.tdr-1': 'Apply for TDR',
  'services.item.tdr-2': 'Track TDR Application',
  'services.item.tdr-3': 'TDR Certificate',
  'services.item.dd-1': 'Apply for Displayer License',
  'services.item.dd-2b': 'Apply for Device Permission (Temporary)',
  'services.item.dd-3': 'Track Workflow Status',
  'services.item.dd-4': 'View Demands & Collection',
  'services.item.dd-5': 'Display Devices Dashboard',
  'services.item.dd-6': 'Rules, Fees & FAQ (GO Ms.No.253)',
  'services.item.tt-1': 'Apply for Tower Clearance',
  'services.item.tt-2': 'Track Application Status',
  'services.item.st-1': 'Smart Township Application',
  'services.item.st-2': 'Track Application Status',
  'services.item.uda-1': 'UDA Building Permissions',
  'services.item.uda-2': 'UDA Layout Approvals',
  'services.item.uda-3': 'UDA Development Charges',
  'services.item.uda-4': 'UDA Regional Services',

  // Contact Section
  'contact.title': 'Contact Us',
  'contact.description': 'Get in touch with DTCP for queries related to building permissions, layout approvals, master plans, and other town planning services.',
  'contact.headOffice': 'DTCP Head Office',
  'contact.headOfficeDesc': 'Directorate of Town & Country Planning, Government of Andhra Pradesh.',
  'contact.regionalOffices': 'Regional Offices',
  'contact.regionalOfficesDesc': 'DTCP has 4 Regional Offices across Andhra Pradesh.',
  'contact.helpDesk': 'Help Desk',
  'contact.helpDeskDesc': 'For queries related to online services, application status, and general information.',
  'contact.helpline': 'Helpline',
  'contact.emailSupport': 'Email',
  'contact.supportHours': 'Working Hours',
  'contact.contactHeadOffice': 'Contact Head Office',
  'contact.viewRegionalOffices': 'View Regional Offices',
  'contact.getHelp': 'Get Help',
  'contact.downloads': 'Downloads & Resources',
  'contact.applicationForms': 'Application Forms',
  'contact.feeStructure': 'Fee Structure',
  'contact.developmentRules': 'Development Control Rules',
  'contact.masterPlans': 'Master Plans',
  'contact.updates': 'Latest Updates',
  'contact.gosCirculars': "GO's & Circulars",
  'contact.tenders': 'Tenders & Notices',
  'contact.pressReleases': 'Press Releases',
  'contact.recruitments': 'Recruitments',
};
